<template>
  <div class="chatSendButton">
    <div class="chatSendButtonIcon"></div>
  </div>
</template>

<script>

  export default {
    name: 'ChatSendButton',
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
    }
  }
</script>

<style lang="scss">
@import "src/assets/scss/variables";

.chatSendButton {

  display: inline-flex;
  justify-content: center;
  align-content: center;

  height: $primaryInputButtonHeight;
  width: $primaryInputButtonWidth;
  outline: none !important;

  /*padding-right: 18px;
  padding-left: 18px;
  padding-top: 13px;
  padding-bottom: 13px;*/
}

.chatSendButtonIcon {
  background-image: url("/icons/send.svg");
  align-self: center;
  background-repeat: no-repeat;
  width: 21px;
  height: $secondaryTextFontSize;
  display: inline-block;
}

.chatSendButtonIcon:active {
  background-image: url("/icons/send-active.svg");

}

</style>
